type OptionsCommon = any

type ResponseCommon = {
  type: 'form'
}

export const FormCommon = (options?: OptionsCommon): ResponseCommon => {
  return {
    type: 'form',
  }
}

export type FormCommonType = ReturnType<typeof FormCommon>
